export interface UserListDB {
    avatar: string;
    fName: string;
    lName: string;
    email: string;
    last_login: string;
    role: string;
}

export const USERLISTDB: UserListDB[] = [
    {
        avatar: 'assets/images/dashboard/user5.jpg',
        fName: "Rowan",
        lName: "Torres",
        email: "Rowan.torres@gmail.com",
        last_login: "6 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user3.jpg',
        fName: "Alonzo",
        lName: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user1.jpg',
        fName: "Skylar",
        lName: "Lane",
        email: "Lane.Skylar@gmail.com",
        last_login: "1 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/boy-2.png',
        fName: "Brody",
        lName: "Gray",
        email: "Gray.Brody@gmail.com",
        last_login: "3 Days ago",
        role: "Admin",
    },
    {
        avatar: 'assets/images/dashboard/designer.jpg',
        fName: "Colton",
        lName: "Clay",
        email: "Colton.Clay@gmail.com",
        last_login: "1 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user.png',
        fName: "Maxine",
        lName: "Woters",
        email: "woters.maxine@gmail.com",
        last_login: "10 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user3.jpg',
        fName: "Alonzo",
        lName: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user1.jpg',
        fName: "Skylar",
        lName: "Lane",
        email: "Lane.Skylar@gmail.com",
        last_login: "1 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/boy-2.png',
        fName: "Brody",
        lName: "Gray",
        email: "Gray.Brody@gmail.com",
        last_login: "3 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/designer.jpg',
        fName: "Colton",
        lName: "Clay",
        email: "Colton.Clay@gmail.com",
        last_login: "1 Days ago",
        role: "Admin",
    },
    {
        avatar: 'assets/images/dashboard/user.png',
        fName: "Maxine",
        lName: "Woters",
        email: "woters.maxine@gmail.com",
        last_login: "10 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user3.jpg',
        fName: "Alonzo",
        lName: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user1.jpg',
        fName: "Skylar",
        lName: "Lane",
        email: "Lane.Skylar@gmail.com",
        last_login: "1 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/boy-2.png',
        fName: "Brody",
        lName: "Gray",
        email: "Gray.Brody@gmail.com",
        last_login: "3 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/designer.jpg',
        fName: "Colton",
        lName: "Clay",
        email: "Colton.Clay@gmail.com",
        last_login: "1 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user5.jpg',
        fName: "Rowan",
        lName: "Torres",
        email: "Rowan.torres@gmail.com",
        last_login: "6 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user3.jpg',
        fName: "Alonzo",
        lName: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Admin",
    },
    {
        avatar: 'assets/images/dashboard/user1.jpg',
        fName: "Skylar",
        lName: "Lane",
        email: "Lane.Skylar@gmail.com",
        last_login: "1 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/boy-2.png',
        fName: "Brody",
        lName: "Gray",
        email: "Gray.Brody@gmail.com",
        last_login: "3 Days ago",
        role: "Admin",
    },
    {
        avatar: 'assets/images/dashboard/designer.jpg',
        fName: "Colton",
        lName: "Clay",
        email: "Colton.Clay@gmail.com",
        last_login: "1 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user.png',
        fName: "Maxine",
        lName: "Woters",
        email: "woters.maxine@gmail.com",
        last_login: "10 Days ago",
        role: "Customer",
    },
    {
        avatar: 'assets/images/dashboard/user3.jpg',
        fName: "Alonzo",
        lName: "Perez",
        email: "Perez.Alonzo@gmail.com",
        last_login: "2 Days ago",
        role: "Customer",
    },


]
